module.exports = __webpack_public_path__ + "img/Camera.e2880781.png";